import { useMemo } from 'react'

import { useAtomValue } from 'jotai'

import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

import {
  editingVersionAtom,
  presentationAtom,
  useResolvedNodeDefinitions
} from 'Automations/automationEditor/atoms'
import { getStartNode } from 'Automations/nodeDefinitions'
import { NodeType } from 'Automations/nodeDefinitions/types'

type TriggerType = Dashboardv99990101Api.Automations.TriggerType

export const useEditingTriggerType = (): TriggerType | undefined => {
  const presentation = useAtomValue(presentationAtom)
  const editingVersion = useAtomValue(editingVersionAtom)
  const definitions = useResolvedNodeDefinitions()

  return useMemo(() => {
    if (presentation) {
      const startNode = getStartNode(presentation, definitions)
      if (startNode?.type) {
        const definition = definitions[startNode.type as NodeType]
        if (definition?.startNodeTriggerType) {
          return definition.startNodeTriggerType
        }
      }
    }
    return editingVersion?.triggerType
  }, [presentation, editingVersion, definitions])
}
